module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Artboard 2\n  </title>\n  <path d=\"M7.2 1v8c0 .552-.403 1-.9 1s-.9-.448-.9-1v-.073C5.397 5.51 4.969 1 4.969 1H4.05s-.447 4.51-.45 7.927V9c0 .552-.403 1-.9 1s-.9-.448-.9-1V1H.9S.006 5.51 0 8.927V11c0 3 3 2 3 5v1h3v-1c0-3 3-2 3-5V8.958C8.994 5.51 8.1 1 8.1 1h-.9zM18 0v17h-3v-3h-3c0-7 2-12 6-14\" fill=\"#15100C\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/icon-18-food-and-drink.svg
// module id = 3708
// module chunks = 168707334958949